import React from 'react';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { InfoListItem } from '@brightlayer-ui/react-components';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { ListItemText, Typography } from '@mui/material';
import { SiteRoleData, Status, UserRole } from '../../types';
import { StatusTag } from '../StatusTag/StatusTag';

export const UserLocation: React.FC<{
    organizationName: string;
    location: SiteRoleData[];
}> = (props) => {
    const { t } = useLanguageLocale();

    return (
        <div key={'location-role-info'}>
            <InfoListItem
                key="orgName"
                divider={'full'}
                title={props.organizationName}
                data-testid="org-name"
                icon={<BusinessIcon />}
                subtitle={t('USER_SETTINGS.ORGANIZATION_NAME')}
            ></InfoListItem>

            {props.location.length > 0 &&
                props.location.map((loc, index) => (
                    <div key={index}>
                        <InfoListItem
                            key={`${loc.siteId}${index}`}
                            divider={'full'}
                            title=""
                            wrapTitle={true}
                            data-testid="org"
                            icon={<LocationOnIcon />}
                            leftComponent={
                                <React.Fragment key={index}>
                                    <ListItemText style={{ fontWeight: 'bold', maxWidth: 500, minWidth: 500 }}>
                                        <Typography
                                            style={{
                                                fontWeight: 600,
                                                paddingRight: 30,
                                                wordBreak: 'break-all',
                                                wordWrap: 'break-word',
                                            }}
                                            variant="body1"
                                        >
                                            {loc.siteName}
                                        </Typography>

                                        <Typography style={{ fontWeight: 400 }} variant="subtitle2">
                                            Location
                                        </Typography>
                                    </ListItemText>
                                    <ListItemText style={{ fontWeight: 600 }}>
                                        <Typography style={{ fontWeight: 600 }} variant="body1">
                                            Role: {loc.roleName}
                                        </Typography>
                                        <Typography style={{ fontWeight: 400 }} variant="subtitle2">
                                            Address: {loc.siteAddress}
                                        </Typography>
                                    </ListItemText>
                                </React.Fragment>
                            }
                            rightComponent={
                                loc.roleName === UserRole.Unassigned ? <div><StatusTag status={Status.Unassigned} /></div>
                                    : <div><StatusTag status={Status.Active} /></div>
                            }
                        ></InfoListItem>
                    </div>
                ))}
        </div>
    );
};
